import type { ServiceResponse } from './types';
import { apiRequest } from '../utils/api';

// Backend response types (simplified)
export interface NewsletterResponseDto {
  _id: string;
  id: string;
  email: string;
  name?: string;
  subscribedAt: string;
  createdAt: string;
  updatedAt: string;
}

// Frontend types (simplified)
export interface NewsletterSubscription {
  id: string;
  email: string;
  name?: string;
  subscribedAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface SubscribeRequest {
  email: string;
  name?: string;
}

class NewsletterService {
  private readonly baseUrl = '/newsletter';

  // Transform backend response to frontend format
  private transformSubscription(dto: NewsletterResponseDto): NewsletterSubscription {
    return {
      id: dto.id || dto._id,
      email: dto.email,
      name: dto.name,
      subscribedAt: new Date(dto.subscribedAt),
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt)
    };
  }

  // Subscribe to newsletter
  async subscribe(data: SubscribeRequest): Promise<ServiceResponse<NewsletterSubscription>> {
    try {
      const payload = {
        email: data.email,
        name: data.name
      };

      const response = await apiRequest<NewsletterResponseDto>(
        `${this.baseUrl}/subscribe`,
        {
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );

      return {
        success: true,
        data: this.transformSubscription(response),
        message: 'Successfully subscribed to newsletter'
      };
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      return {
        success: false,
        data: {} as NewsletterSubscription,
        error: error instanceof Error ? error.message : 'Failed to subscribe to newsletter'
      };
    }
  }
}

export const newsletterService = new NewsletterService();